<!-- <p>incident-heat-map works!</p> -->
<div class="button-container">
  <button
    matTooltip="Click to view details"
    matTooltipPosition="right"
    (click)="onClickOpen()"
    mat-icon-button
  >
    <mat-icon>info</mat-icon>
  </button>
</div>
<google-map
  [width]="'100%'"
  [height]="screenSize === ScreenType.Mobile ? '320px' : '640px'"
  *ngIf="isLoaded"
  [center]="center"
  [zoom]="10"
  id="heatmap"
>
  <map-heatmap-layer [data]="heatmapData" [options]="heatmapOptions" />
  <map-info-window>{{ infoWindowContent | json }}</map-info-window>
</google-map>
<ng-template #DetailsDialog>
  <div class="details-wrapper">
    <div class="aumye-header">
      HeatMap Details
      <button style="right: 10px" mat-mini-fab mat-dialog-close>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
    <div class="details-content">
      <div
        *ngFor="let item of heatMapGraphData"
        class="details-content-wrapper"
      >
        <div class="details-card-content">
          <div>
            Asset Name : <b>{{ item.assetName | titlecase }}</b>
          </div>
          <div>
            Asset Location : <b>{{ getAssetLocation(item.assetLocation) }}</b>
          </div>
          <div>
            Incident Counts : <b>{{ item.incidentCount }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
